import React, { useRef, useState } from 'react';
import bem from 'utils/bem';
import Popover from '@mui/material/Popover';
import InlineDateTimeField from './InlineDateTimeField';
import { Button } from 'components/Button';
import Text from 'components/Text';

const { block, el } = bem('datetime-field', 'popover-datetime-field');
const PopoverDateTimeField = ({ anchorEl, open, onClose, Field = null, ...rest }) => {

    const [ saveDisabled, setSaveDisabled ] = useState(true);

    const classes = {
        paper: el('paper')
    };

    const ref = useRef();

    const updatePosition = () => {
        ref.current && ref.current.updatePosition();
    }

    const InlineField = Field ? Field : InlineDateTimeField;

    return (
        <div className={block()}>
            <Popover
                action={ref}
                open={open}
                onClose={onClose}
                classes={classes}
                anchorEl={anchorEl}
                anchorOrigin={{vertical: 'center', horizontal: 'left'}}
            >
                <InlineField {...rest} onClose={onClose} updatePosition={updatePosition} setSaveDisabled={setSaveDisabled} />
                <div className={el('save')}>
                    <Button mod={'gold'} onClick={onClose} disabled={saveDisabled}><Text>Сохранить</Text></Button>
                </div>
            </Popover>
        </div>
    );
};

export default PopoverDateTimeField;



